import { call, put, all, takeLatest } from "redux-saga/effects";
import {
  fetchStructureNoteInfo,
  fetchStructureNoteInfoSuccess,
  fetchStructureNoteInfoFailure,
} from "redux/reducers/structure-note";
import { StructureNoteAPI } from "services/structure-note";

function* fetchStructureNoteInfoSaga() {
  try {
    const [responseData, responseDocs] = yield all([
      call(StructureNoteAPI.getStructureNote),
      call(StructureNoteAPI.getStructureNoteDocuments),
    ]);
    yield put(
      fetchStructureNoteInfoSuccess({
        inventory: responseData.data.structureNote || {},
        documents: responseDocs.data.listAllStructureNote || [],
      })
    );
  } catch (error) {
    console.error(error)
    yield put(fetchStructureNoteInfoFailure(error));
  }
}

const saga = [takeLatest(fetchStructureNoteInfo.type, fetchStructureNoteInfoSaga)];

export default saga;
